export default {
  portfolio: {
    title: 'Portfolio',
    contents: {
      design: {
        title: 'DISEÑO',
        description: 'Creamos la identidad gráfica de tu empresa. También diseñamos material publicitario (afiches, folletos y otros). ¡Nuestro diseñador tiene unas ideas brutales!'
      },
      software: {
        title: 'SOFTWARE',
        description: 'Creamos sistemas informáticos para una adecuada gestión de las operaciones de tu empresa.'
      },
      app: {
        title: 'APP',
        description: 'Desarrollamos aplicaciones móviles que brindan soluciones prácticas a las necesidades de tus clientes.'
      },
      web: {
        title: 'WEB',
        description: 'Creamos sitios web atractivos, rápidos, seguros. Si no tienes una idea clara, te ayudamos a tomar la mejor decisión.'
      }
    },
    textHeader: 'LO QUE HACEMOS',
    textFooter: 'Nos especializamos en desarrollo web, desarrollo de apps, diseño gráfico y en sacar de apuros a los clientes',
    modal: {
      tecnology: 'TECNOLOGÍAS: '
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/es/portfolio.js